import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Stack, Typography } from '@mui/material';
import { RISK_STATUS } from '../../constants/cache-constants';
import { RISK_STATUS_COLORS, RISK_STATUS_TEXT } from '../../constants/external-risk-status';
import { ErrorCodeType } from '../../propTypes';
import { formatDateTime } from '../../helpers';
import { getDisplayableErrorCodes, getErrorCodeText } from '../../helpers/error-codes';
import StatusBubbleMarker from '../markers/StatusBubbleMarker';

const CompanyRiskStatusTooltip = ({ masterEntity }) => {
  const riskStatus = useMemo(() => (masterEntity.clientExternalRiskStatus
    ?? masterEntity.debtorExternalRiskStatus ?? null), [masterEntity]);
  const nonZeroErrors = useMemo(() => getDisplayableErrorCodes(riskStatus), [riskStatus]);
  if (!riskStatus || riskStatus.status === RISK_STATUS.NOT_REQUIRED) return <></>;

  const title = (
    <>
      <Stack direction="column">
        <Typography variant="body2">Riesgo {RISK_STATUS_TEXT[riskStatus.status]}</Typography>
        {riskStatus.updatedAt && (
          <Typography variant="body2">
            Fecha consulta: {formatDateTime(riskStatus.updatedAt)}
          </Typography>
        )}
        { nonZeroErrors.map((errorCode) => (
          <Typography key={errorCode.id} variant="body2">{getErrorCodeText(errorCode)}</Typography>
        ))}
      </Stack>
    </>
  );

  return (
    <>
      <Tooltip title={title}>
        <StatusBubbleMarker color={RISK_STATUS_COLORS[riskStatus.status]} label="R" />
      </Tooltip>
    </>
  );
};

CompanyRiskStatusTooltip.propTypes = {
  masterEntity: PropTypes.shape({
    clientExternalRiskStatus: PropTypes.shape({
      status: PropTypes.string,
      errorCode: ErrorCodeType,
      detailedErrorCodes: PropTypes.arrayOf(ErrorCodeType),
      updatedAt: PropTypes.string,
    }),
    debtorExternalRiskStatus: PropTypes.shape({
      status: PropTypes.string,
      errorCode: ErrorCodeType,
      detailedErrorCodes: PropTypes.arrayOf(ErrorCodeType),
      updatedAt: PropTypes.string,
    }),
  }).isRequired,
};

export default CompanyRiskStatusTooltip;
